import { render, staticRenderFns } from "./ClinicalTrialCoqun.vue?vue&type=template&id=136896c6&scoped=true&"
import script from "./ClinicalTrialCoqun.vue?vue&type=script&lang=js&"
export * from "./ClinicalTrialCoqun.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalTrialCoqun.vue?vue&type=style&index=0&id=136896c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136896c6",
  null
  
)

export default component.exports